import { createContext, useContext } from 'react';
import { IService } from 'services/IService';
import { ST } from 'types';

export type IGeoLocationService = {
  getCurrentLocation: () => Promise<ST.Location>;
  getAddressFromLocation: (pos: ST.Location) => Promise<string>;
} & IService;

const GeoLocationContext = createContext<null | IGeoLocationService>(null);

export const GeoLocationProvider = GeoLocationContext.Provider;
export function useGeoLocation() {
  const svc = useContext(GeoLocationContext);
  if (svc === null) {
    // Fallback: DummyGeoLocator verwenden, wenn kein echter Service verfügbar ist
    // Dynamisch importieren, um Zirkularität zu vermeiden
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const DummyGeoLocator = require('./DummyGeoLocator').default;
    return new DummyGeoLocator();
  }
  return svc;
}
